// A screen that exists in the plan but not yet in the build: keeps the nav whole while the phases land.
import { useNavigate } from "react-router-dom";
import { Page } from "@/app/Page";
import { Button, Card, Empty } from "@/kit/primitives";
import { useSession } from "@/state/session";

export function ComingSoon({ title, phase }: { title: string; phase: string }) {
  const nav = useNavigate();
  const wid = useSession((s) => s.wid);
  return (
    <Page header={{ kind: "title", title: title.toUpperCase(), subtitle: "Coming soon" }}>
      <Card>
        <Empty>
          The {title} screen is built in {phase} of the plan.
          <div style={{ marginTop: 18 }}>
            <Button onClick={() => nav(wid ? `/w/${wid}` : "/portal")}>Back to {wid ? "your city" : "Portal"}</Button>
          </div>
        </Empty>
      </Card>
    </Page>
  );
}
